import { render, staticRenderFns } from "./full-agreement.vue?vue&type=template&id=563d313c&scoped=true&"
import script from "./full-agreement.vue?vue&type=script&lang=js&"
export * from "./full-agreement.vue?vue&type=script&lang=js&"
import style0 from "./full-agreement.vue?vue&type=style&index=0&id=563d313c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d313c",
  null
  
)

export default component.exports